import { GridAction } from '@eforall/dashboard';
import { AlignedAccelerator } from '../aligned-accelerators.part';

export function getActions() {

	const actions: GridAction<AlignedAccelerator>[] = [
	];

	return actions;
}